var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledListViewLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.14,
    height: 18.532,
    viewBox: "0 0 18.14 18.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_603",
    "data-name": "Union 603",
    d: "M-3899.452-88.219a5.22,5.22,0,0,1-3.728-1.331,5.084,5.084,0,0,1-1.408-3.766v-8.418a4.964,4.964,0,0,1,1.412-3.714,5.275,5.275,0,0,1,3.724-1.3h7.877a5.215,5.215,0,0,1,3.8,1.377,4.99,4.99,0,0,1,1.325,3.642v8.486a4.981,4.981,0,0,1-1.407,3.717,5.27,5.27,0,0,1-3.729,1.309Zm-3.741-13.515v8.418c0,2.387,1.329,3.7,3.741,3.7h7.868c2.413,0,3.742-1.289,3.742-3.63v-8.489a3.6,3.6,0,0,0-.919-2.656,3.873,3.873,0,0,0-2.813-.966h-7.877C-3901.864-105.355-3903.193-104.069-3903.193-101.733Zm3.833,8.464a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h7.692a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7Zm0-3.333a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h7.692a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7Zm0-3.334a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h7.692a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7Z",
    transform: "translate(3904.588 106.751)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledListViewLight);
export default __webpack_public_path__ + "static/media/disabled_list_view_light.3ba99012f6f2c7e45460aa35308645b2.svg";
export { ForwardRef as ReactComponent };